import { BudgetPhases } from 'business/constants';
import {
    BUDGET_LINE_STATUS_ARBITRATED,
    BUDGET_LINE_STATUS_TODO,
    BUDGET_LINE_STATUS_TO_ARBITRATE,
    SIMULATED_ARBITRATED_AMOUNT,
    SIMULATED_ARBITRATION,
    SIMULATED_ARBITRATION_ENDPOINT,
    SIMULATED_COMMENT,
    SIMULATED_ID,
    SIMULATED_STATUS,
} from 'routes/BudgetModule/config/constants';
import { StatusesSettingsT } from 'routes/BudgetModule/config/types';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import { translateBlockValue } from 'i18n';
import { PhaseHelpers } from '../phase';
import { isInscriptionRejected } from 'routes/BudgetModule/helpers/statusHelpers';

const arbitrageConstants = {
    status: SIMULATED_STATUS,
    inProgressStatus: BUDGET_LINE_STATUS_TODO,
    toValidateStatus: BUDGET_LINE_STATUS_TO_ARBITRATE,
    doneStatus: BUDGET_LINE_STATUS_ARBITRATED,
    comment: SIMULATED_COMMENT,
    amount: SIMULATED_ARBITRATED_AMOUNT,
    id: SIMULATED_ID,
    table: SIMULATED_ARBITRATION,
    endpoint: SIMULATED_ARBITRATION_ENDPOINT,
    name: BudgetPhases.ARBITRAGE,
    isEditable: true,
    isActive: true,
    isSimulated: true,
} as const;

const arbitrageHelpers: PhaseHelpers = {
    isInscriptionRejected: (
        inscription: InscriptionT,
        statusesSettings: StatusesSettingsT,
    ) =>
        isInscriptionRejected(
            inscription,
            BudgetPhases.ARBITRAGE,
            statusesSettings,
        ),
    getPhaseHeaderName: () => translateBlockValue(arbitrageConstants.amount),
} as const;

export const arbitragePhase = {
    ...arbitrageConstants,
    ...arbitrageHelpers,
} as const;
